export const profileRoutes = {
  sendVerificationSms: '/profile/send-verification-sms',
  verificationCheck: '/profile/verification-check',
  login: '/login',
  profile: '/profile',
  loginForm: '/login-form',
  signup: '/signup/:source',
  signupSuccess: '/signup-success',
  createBusinessProfile: '/create-business-profile',
  resetPassword: '/reset-password',
  completeProfile: '/profile/complete-profile',
  sendPasswordSuccessfully: '/send-password-successfully',
  forgetPassword: '/forget-password',
  userBasicInfo: '/profile/user-basic-info',
  changePassword: '/profile/change-password',
  ticket: '/profile/ticket',
  employeeRegistration: '/profile/employee-registration',
  employeeManagement: '/profile/employee-management',
  airlineQuota: '/profile/airline-quota',
  sendTicketComponent: '/profile/send-ticket-component',
  businessProfile: '/profile/business-profile',
  profileSigniture: '/profile/profile-signiture',
  selectProfileType: '/profile/select-profile-type',
  sendProfileForVerification: '/profile/send-profile-for-verification',
  bookingFlights: '/profile/booking-flights',
  financialManagement: '/profile/financial-management',
  rules: '/rules',
  flightRequests: '/profile/user-request',
  userPoint: '/profile/user-point',
  profileDepartment: '/profile/profile-department',
  dashboard: '/profile/dashboard',
  accounting: '/profile/sale-accounting',
  profileAccounts: '/profile/profile-accounts',
  commissionManagement: '/profile/commission-management',
  profileCreditReport: '/profile/profile-credit-report',
  contactUs: '/contact',
  customerManagement: '/profile/customer-managment',
  chargeWallet: '/profile/charge-wallet',
  employeeCreditAllocation: '/profile/employee-credit-allocation',
  myCredit: '/profile/my-credit',
  adminCredit: '/profile/admin-credit',
  DashboardMobile: '/DashboardMobile',
  ActivitiesMobile: '/ActivitiesMobile',
  ExpensesMobile: '/ExpensesMobile',
  Transactions: '/transactions',
  paymentResult: '/payment-result',
  tourManagement: '/profile/tour-management',
  tourDetail: '/tour-detail',
  gateway: '/profile/gateway',
  editIsLockbusinessProfile: '/profile/edit-business-profile',
};
export const flightBookingRoutes = {
  identify: '/booking/identify',
  flightInvoice: '/booking/flight-invoice',
  selectLoginType: '/booking/select-login-type',
  selectFlight: '/booking/select-flight',
  selectFlightDate: '/booking/selcet-flight-date',
  selectCity: '/booking/select-city',
  flightTicket: '/booking/flight-ticket',
  paymentResult: '/booking/payment-result',
  printFlightTicket: '/booking/print-flight-ticket',
  privacy: '/booking/privacy',
  trackingOrder: '/booking/tracking-order',
  amazingTour: '/booking/amazing-tour',
};
export const authenticationRoutes = {
  signup: '/signup',
  login: '/login',
  otpLogin: '/otp-login',
  resetPassword: '/reset-password',
  forgetPassword: '/forget-password',
  sendPasswordSuccessfully: '/send-password-successfully',
};

export const commonRoute = {
  otherOption: '/other-option',
  invoicePayment: '/invoice-payment',
};

export const amazingTourRoutes = {
  addNewTour: '/amazing-tour/add-new-tour',
  // surpriseTourManagement: "/surprise-tour-management",
};

export const gamesRoute = {
  backgammon: 'http://78.39.50.119/',
};

export const testRoute = {
  payment: '/test/payment',
};
